import React from 'react';

const UnitToggle = ({ currentSystem, onToggle }) => {
  return (
    <div className="flex items-center justify-end mb-6">
      <div className="inline-flex p-1 bg-sand border border-sand-dark/10 rounded-full shadow-inner">
        <button
          onClick={() => onToggle('US')}
          className={`px-4 py-1.5 text-xs font-bold rounded-full transition-all duration-300 ${
            currentSystem === 'US' 
              ? 'bg-ube text-white shadow-md' 
              : 'text-gray-500 hover:text-ube'
          }`}
        >
          US
        </button>
        <button
          onClick={() => onToggle('Metric')}
          className={`px-4 py-1.5 text-xs font-bold rounded-full transition-all duration-300 ${
            currentSystem === 'Metric' 
              ? 'bg-ube text-white shadow-md' 
              : 'text-gray-500 hover:text-ube'
          }`}
        >
          Metric
        </button>
      </div>
    </div>
  );
};

export default UnitToggle;